export const CSS_BODY_TAG = 'body {';
